<template>
    <div>
        <section class="bg-white">
            <div class="container">
                <div class="text-block-padding">
                    <h1>Que conclure de vos réponses ?</h1>
                    <p>{{ message }}</p>
                </div>
            </div>
        </section>

        <section class="bg-primary text-white">
            <div class="container">
                <div class="text-block-padding">
                    <h1 class="text-white">Mais attention !</h1>
                    <h2 class="text-white-50 mb-4">Beaucoup de littératures, de discours, de propositions politiques ont
                        été publiés et communiqués par les médias, avec des approches très différentes, à tel point que
                        l’on peut s’y perdre.
                    </h2>
                    <p> Pour simplifier : </p>
                    <ul>
                        <li>il y a ceux qui proposent un revenu minimum inconditionnel venant s’ajouter au millefeuille
                            des aides actuelle et qui serait financé par de nouveaux impôts ou des hausses d’impôts.
                        </li>
                        <li>Il y en a d’autres qui veulent transformer les aides actuelles en une seule aide pour
                            simplifier le millefeuille de celles-ci, mais avec l’intention que cette mesure soit une
                            sorte de « solde de tout compte ».
                        </li>
                        <li>Il y a aussi des partisans d’un revenu de base versé dès la naissance à un niveau parfois
                            progressif selon l’âge sans aucune contre partie, dont le financement pourrait être réalisé
                            par exemple avec un impôt négatif.
                        </li>
                        <li>Il y a enfin les approches sociologiques et psychologiques du Revenu Universel qui cherchent
                            à en tracer les avantages et parfois les inconvénients pour les personnes physiques.
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="bg-white">
            <div class="container">
                <div class="text-block-padding">
                    <h1>Toutes ces approches malheureusement ne sont pas satisfaisantes </h1>
                    <ul>
                        <li>
                            Soit parce qu’elles ne sont tout bonnement pas concrètement applicables.
                        </li>
                        <li>Soit parce qu’elles ne résolvent en rien les difficultés socio-économiques dans lesquelles
                            nous sommes empêtrés depuis des décennies, en ne se concentrant que sur la personne
                            physique.
                        </li>
                        <li>Soit encore parce qu’elles pourraient, comble de paradoxe, engendrer des troubles sociaux.
                        </li>
                        <li>Soit enfin parce qu’elles restent théoriques et n’examinent pas complètement et de façon
                            pragmatique les conséquences de leur mise en place dans notre société, telle qu’elle est
                            aujourd’hui.
                        </li>
                    </ul>
                    <h2>Alors faut-il abandonner cette idée généreuse car elle ne serait pas applicable ? </h2>
                </div>
            </div>
        </section>

        <section class="bg-primary text-white">
            <div class="container">
                <div class="text-block-padding">
                    <h1 class="text-white">Certainement pas, car il faut la regarder totalement différemment</h1>
                    <h2 class="text-white-50 mb-4">C’est ce que je vous propose sur ce site et à travers mon essai
                        « Manuel pratique du Revenu Universel - Vous avez tous à y gagner »</h2>
                    <a :href="root+'/ma-demarche'" class="btn btn-light">Découvrir ma démarche</a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "result",

    mounted() {
        window.scrollTop(0)
    },

    computed: {
        root() {
            return document.head.querySelector('meta[name="root-url"]').content
        },

        message() {
            if (this.padCount > this.nspCount && this.padCount > this.dacCount) {
                return "Vous avez répondu majoritairement PAS D'ACCORD, alors vous pouvez sans crainte entrer dans le monde du Revenu Universel décrit dans mon livre et ainsi à faire évoluer votre avis."
            } else if (this.nspCount > this.padCount && this.nspCount > this.dacCount) {
                return "Vous avez répondu majoritairement NE SAIT PAS, la société du Revenu Universel que j'ai décrite dans mon livre vous apportera des arguments pour vous forger un point de vue positif sur le sujet."
            } else if (this.dacCount > this.nspCount && this.dacCount > this.padCount) {
                return "Vous avez répondu majoritairement D’ACCORD, vous trouverez dans la société du Revenu Universel décrite dans mon livre des arguments tangibles et factuels pour croire fortement en cette idée et avoir envie de la vivre."
            } else {
                return "Aucune majorité ne se dégage de vos réponses, la société du Revenu Universel décrite dans mon livre vous apportera des arguments pour vous forger un point de vue positif sur le sujet."
            }
        },

        ...mapState({
            padCount: state => state.quiz.padCount,
            nspCount: state => state.quiz.nspCount,
            dacCount: state => state.quiz.dacCount,
        }),
    }
}
</script>

<style scoped>

</style>
